import React from 'react';
import {
  Navbar,
  Nav,
} from 'reactstrap';

import PdxNavLink from '../PdxNavLink';
import RightNav from '../RightNav';
import Logo from '../../Logo';
import PdxNavItem from '../PdxNavItem';
import { LINK_IDS } from '../nav-links';
import '../NavbarVariant.css';
import '../MagicLine.css';
import './DeveloperNavbar.css';

const DeveloperNavbar = () => (
  <div className="navbar-variant">
    <Navbar expand="md">
      <Logo />
      <div className="developer-badge">Developer</div>
      <Nav className="mr-auto ml-0" navbar>
        <PdxNavItem id={LINK_IDS.DEVELOPER_DOCUMENTATION} style={{ width: '190px' }}>
          <PdxNavLink id={LINK_IDS.DEVELOPER_DOCUMENTATION} />
        </PdxNavItem>
        <PdxNavItem id={LINK_IDS.API_REFERENCE} style={{ width: '190px' }}>
          <PdxNavLink id={LINK_IDS.API_REFERENCE} />
        </PdxNavItem>
        <PdxNavItem id={LINK_IDS.MY_APPS} style={{ width: '160px', paddingRight: '8px' }}>
          <PdxNavLink id={LINK_IDS.MY_APPS} />
        </PdxNavItem>
        <span className="magicLine developerNavbar" />
      </Nav>
      <RightNav isDeveloperNav />
    </Navbar>
  </div>
);

export default DeveloperNavbar;
